import React, { useState, useEffect } from "react";

const IncrementCounter = ({
  intialCount,
  startYear,
  incrementPerYear,
  classes,
  style,
}) => {
  const [count, setCount] = useState(intialCount);

  useEffect(() => {
    const currentYear = new Date().getFullYear();
    const yearsPassed = currentYear - startYear;
    setCount(intialCount + yearsPassed * incrementPerYear);
  }, [intialCount, startYear, incrementPerYear]);

  return (
    <span className={classes} style={style}>
      {count.toLocaleString()}
    </span>
  );
};

export default IncrementCounter;
